import React from "react";

const RolesManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47.158"
      height="47.159"
      viewBox="0 0 47.158 47.159"
    >
      <g id="db59" transform="translate(-141.093 -143.095)">
        <path
          id="Path_1335"
          data-name="Path 1335"
          d="M392.263,385.767l-6.973,6.972a.78.78,0,0,1-.365.206l-4.448,1.111a.8.8,0,0,1-.19.023.786.786,0,0,1-.762-.977l1.112-4.445a.778.778,0,0,1,.208-.365l5-5h0l1.971-1.97h0a1.931,1.931,0,0,1,2.727,0l1.719,1.719a1.928,1.928,0,0,1,0,2.728M385.789,376a11.79,11.79,0,1,0,11.789,11.789A11.8,11.8,0,0,0,385.789,376"
          transform="translate(-209.327 -209.328)"
          fill={fill ? fill : "#a07eff"}
          fillRule="evenodd"
        />
        <path
          id="Path_1336"
          data-name="Path 1336"
          d="M509.408,438.578a.358.358,0,0,0-.5,0l-1.415,1.416,2.223,2.223,1.415-1.415a.356.356,0,0,0,0-.5Z"
          transform="translate(-329.302 -265.475)"
          fill={fill ? fill : "#a07eff"}
          fillRule="evenodd"
        />
        <path
          id="Path_1337"
          data-name="Path 1337"
          d="M447.531,468.758l-.741,2.963,2.965-.74,4.292-4.292-2.224-2.223Z"
          transform="translate(-274.748 -288.836)"
          fill={fill ? fill : "#a07eff"}
          fillRule="evenodd"
        />
        <path
          id="Path_1338"
          data-name="Path 1338"
          d="M166.822,146.239a.775.775,0,0,1,.786-.786h3.93a.786.786,0,0,1,0,1.572h-3.93A.775.775,0,0,1,166.822,146.239Zm7.86-.786a.786.786,0,1,1-.786.786A.775.775,0,0,1,174.682,145.453Zm3.144,0H179.4a.786.786,0,0,1,0,1.572h-1.572a.786.786,0,1,1,0-1.572Zm-8.646,6.288c0-1.3.218-1.572,1.572-1.572H200.62c1.354,0,1.572.272,1.572,1.572v.786h3.93V148.6a.776.776,0,0,0-.786-.786H186.362a2.539,2.539,0,0,1-1.474-.472l-5.676-4.087a.848.848,0,0,0-.492-.157H166.167a.8.8,0,0,0-.819.786v8.646h3.832Z"
          transform="translate(-21.799)"
          fill={fill ? fill : "#a07eff"}
          fillRule="evenodd"
        />
        <path
          id="Path_1339"
          data-name="Path 1339"
          d="M197,313.89a1.572,1.572,0,1,0,1.572,1.572A1.574,1.574,0,0,0,197,313.89"
          transform="translate(-48.839 -153.503)"
          fill={fill ? fill : "#a07eff"}
          fillRule="evenodd"
        />
        <path
          id="Path_1340"
          data-name="Path 1340"
          d="M275.429,298.36a2.358,2.358,0,1,0,2.358,2.358,2.361,2.361,0,0,0-2.358-2.358"
          transform="translate(-118.617 -139.546)"
          fill={fill ? fill : "#a07eff"}
          fillRule="evenodd"
        />
        <path
          id="Path_1341"
          data-name="Path 1341"
          d="M162.647,264.114a7.078,7.078,0,0,1,.856-1.781l.109-.163a3.145,3.145,0,1,1,3.7-.009l.124.185a7.11,7.11,0,0,1,.856,1.78.787.787,0,0,1-.511.987.8.8,0,0,1-.239.038.787.787,0,0,1-.749-.548,5.5,5.5,0,0,0-.665-1.386l-.315-.472a3.057,3.057,0,0,1-.358.036,3.149,3.149,0,0,1-.342-.034l-.306.458a5.5,5.5,0,0,0-.666,1.386.786.786,0,0,1-1.5-.476Zm-.333,5.741a.786.786,0,1,1-1.572,0v-.938a7.039,7.039,0,0,0-2.654-5.523l-.822-.658a2.282,2.282,0,0,1-.907,0l-.821.658a7.039,7.039,0,0,0-2.655,5.523v.938a.786.786,0,1,1-1.572,0v-.938a8.6,8.6,0,0,1,3.246-6.751l.067-.053a3.929,3.929,0,1,1,4.38,0l.067.053a8.605,8.605,0,0,1,3.244,6.751ZM150.467,265.1a.784.784,0,0,1-.987-.511,5.466,5.466,0,0,0-.666-1.386l-.3-.458a1.719,1.719,0,0,1-.685,0l-.306.458a5.487,5.487,0,0,0-.925,3.053V267.5a.786.786,0,0,1-1.572,0v-1.239a7.053,7.053,0,0,1,1.188-3.925l.11-.163a3.143,3.143,0,1,1,3.693,0l.108.163a7.051,7.051,0,0,1,.856,1.781.786.786,0,0,1-.511.987ZM163.1,276.142a13.362,13.362,0,0,1,22.272-9.957.786.786,0,0,0,1.11-.061,946.348,946.348,0,0,0,.2-.985v-11a2.361,2.361,0,0,0-2.358-2.358H143.451a2.361,2.361,0,0,0-2.358,2.358V284c0,1.1.89,2.358,1.67,2.358h22.7a.762.762,0,0,0,.229-.047.776.776,0,0,0,.817-1.262,13.337,13.337,0,0,1-3.4-8.91Z"
          transform="translate(0 -97.678)"
          fill={fill ? fill : "#a07eff"}
          fillRule="evenodd"
        />
        <path
          id="Path_1342"
          data-name="Path 1342"
          d="M367.809,317.04a1.572,1.572,0,1,0-1.572-1.572,1.573,1.573,0,0,0,1.572,1.572"
          transform="translate(-202.351 -153.509)"
          fill={fill ? fill : "#a07eff"}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default RolesManagementIcon;
